export const API_WEB_URLS = {
  BASE: "https://apikirayago.shinewellsofttech.co.in/api/V1/",
  // BASE: "http://10.136.68.48:7037/api/V1/",
  // BASE: "https://localhost:44379/api/V1/",

  //   LOGIN: "Authentication/Login",
  //   IMAGEURL: "https://localhost:44362/MemberImages/",
  //    IMAGEURL: "https://apiinventory.shinewellinnovation.com/MemberImages/",
  //  IMAGEURL: "http://192.168.31.70:7037/MemberImages/",
  IMAGEURL: "https://apikirayago.shinewellsofttech.co.in/MemberImages/",
  // IMAGEURL: "http://192.168.1.46:7037/MemberImages/",
  // IMAGEURL_PDF:  "https://apiinventory.shinewellinnovation.com/MemberImages/PDF/",
  
  MASTER: "Masters",

  StockMaster_OtherData: "Masters/0/token/StockMaster_OtherData/Id/",
  DesktopData: "Masters/0/token/DesktopData/Id/",

  CUSTOMER: "CustomerMaster",
  FirmMaster: "FirmMaster",
  BranchMaster: "BranchMaster",
  TypeMaster: "TypeMaster",
  StateMaster: "StateMaster",
  CityMaster: "CityMaster",
  CountryMaster: "CountryMaster",
  UserTypeMaster: "UserTypeMaster",
  CommissionMaster: "CommissionMaster",
  VehicleRateMaster: "VehicleRateMaster",
  VehicleTypeInstructionMaster: "VehicleTypeInstructionMaster",
  AreaZoneMaster: "AreaZoneMaster",
  GoodsTypeMaster: "GoodsTypeMaster",
  GoodsTypeMasterActive: "GoodsTypeMasterActive",
  ItemTypeMaster: "ItemTypeMaster",
  UnitMaster: "UnitMaster",
  ItemMaster: "ItemMaster",
  ClassLab: "ClassLab",
  ClassItemMap: "ClassItemMap",
  StockMaster: "StockMaster",
  NotesCommentMaster: "NotesCommentMaster",
  AuthorMaster: "AuthorMaster",
  BookMaster: "BookMaster",
  BookTypeMaster: "BookTypeMaster",
  RackMaster: "RackMaster",
  SupplierMaster: "SupplierMaster",
  PurchaseMaster: "PurchaseMaster",
  RackCapacityMapWithUniqueAccountNo: "RackCapacityMapWithUniqueAccountNo",
  TeacherDocumentMapMaster: "TeacherDocumentMapMaster",
  Challan: "Challan",
  ItemGroupMaster: "ItemGroupMaster",
  POApprovedByAdmin: "POApprovedByAdmin",
  SOApprovedByAdmin: "SOApprovedByAdmin",
  //Reports
  StudentDetails: "StudentDetails",
  StudentLedgerDetails: "StudentLedgerDetails",
  AttendanceReport: "AttendanceReport",
  StudentReport: "StudentReport",
  StudentLessonDetails: "StudentLessonDetails",
  TeachersReport: "TeachersReport",

  // ── Accounting Reports (dedicated endpoints) ──────────────────────────
  // Ledger Report: All Ledgers List
  LEDGER_REPORT_LIST: "LedgerReport", // GET /{UserId}/{Token}/List?fromDate=&toDate=
  // Ledger Report: Single Ledger Voucher Statement
  LEDGER_REPORT_STATEMENT: "LedgerReport", // GET /{UserId}/{Token}/Statement/{LedgerId}?fromDate=&toDate=
  // Balance Sheet Summary
  BALANCE_SHEET_SUMMARY: "BalanceSheet", // GET /{UserId}/{Token}/Summary?asOnDate=
  // Profit & Loss Report Summary
  PROFIT_LOSS_REPORT: "ProfitLossReport", // GET /{UserId}/{Token}/Summary?fromDate=&toDate=&bookingId=
  // Manual Voucher Entry
  VOUCHER_ENTRY: "VoucherEntry", // POST /{UserId}/{Token}/Save, GET /{UserId}/{Token}/Recent, GET /{UserId}/{Token}/Ledgers
  // ─────────────────────────────────────────────────────────────────────

  // ── Custom Notification & Marketing ──────────────────────────────
  CUSTOM_NOTIFICATION: "CustomNotification", // GET/POST /{UserId}/{Token}/...
  // ─────────────────────────────────────────────────────────────────────

  //KreditBEast
  PropertyDeal: "PropertyDeal",
  GoldDeal: "GoldDeal",

  Token:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImluZm9Ac2hpbmV3ZWxsaW5ub3ZhdGlvbi5jb20iLCJuYW1laWQiOiIxIiwidW5pcXVlX25hbWUiOiIzMTZiYmI3Ny1kOWIxLTQwNWYtYWRiYy01YzYyN2I0M2YwOWQiLCJJUCI6IjQ5LjQzLjE3Ni45NSIsImlzc3VlZF9kYXRlIjoiMTY5NDQzMjU3MyIsIm5iZiI6MTY5NDQzMjU3MywiZXhwIjoxNjk1MDM3MzczLCJpYXQiOjE2OTQ0MzI1NzMsImlzcyI6Imh0dHA6Ly9zaGluZXdlbGxzb2Z0dGVjaC5jby5pbjo1MDY5My9yZXBvcnRpbmcvc2l0ZS9zaXRlMSIsImF1ZCI6Imh0dHA6Ly9zaGluZXdlbGxzb2Z0dGVjaC5jby5pbjo1MDY5My9yZXBvcnRpbmcvc2l0ZS9zaXRlMSJ9.thpdYXJuKWTDlStV-HHTv6PViEDZPrSQDO9C3aUo4mM",
}
